import { render, staticRenderFns } from "./BusinessIncentives.vue?vue&type=template&id=1b14b605&scoped=true"
import script from "./BusinessIncentives.vue?vue&type=script&lang=js"
export * from "./BusinessIncentives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b14b605",
  null
  
)

export default component.exports